import DecorationPreviewItem from './DecorationPreviewItem';

export default DecorationPreviewItem;
export { DecorationPreviewItem };
